"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formatStringWithMeasurementSystem = _interopRequireDefault(require("../display/formatStringWithMeasurementSystem"));

var _formatDistanceWithMeasurementSystem = _interopRequireDefault(require("../display/formatDistanceWithMeasurementSystem"));

var _extractTargetUnit = _interopRequireDefault(require("../display/extractTargetUnit"));

var _formatNumber = _interopRequireDefault(require("../char/formatNumber"));

var _constants = require("./constants");

var _types = require("./types");

var getUserActionLiteralObjective = function getUserActionLiteralObjective(_ref) {
  var _conditions$userActio;

  var literal = _ref.literal,
      conditions = _ref.conditions,
      t = _ref.t;
  var userActionType = conditions === null || conditions === void 0 ? void 0 : (_conditions$userActio = conditions.userActionsTypes) === null || _conditions$userActio === void 0 ? void 0 : _conditions$userActio.find(function (type) {
    return Object.keys(_constants.actionsTypesMapping).includes(type);
  });
  if (!userActionType) return literal;
  var baseObjective = "".concat(literal).concat(t(_constants.actionsTypesMapping[userActionType]));
  var shouldAppendWithMedia = (conditions === null || conditions === void 0 ? void 0 : conditions.withMedia) && (userActionType === _types.UserActionsType.FEED_MESSAGE || userActionType === _types.UserActionsType.FEED_ACTIVITY_SHARE);
  var objectiveName = shouldAppendWithMedia ? "".concat(baseObjective, "_with_media") : baseObjective;

  if (!!(conditions === null || conditions === void 0 ? void 0 : conditions.frequency) && !!(conditions === null || conditions === void 0 ? void 0 : conditions.frequencyRepeat) && !!(conditions === null || conditions === void 0 ? void 0 : conditions.repeat)) {
    objectiveName += "".concat(t((conditions === null || conditions === void 0 ? void 0 : conditions.repeat) > 1 ? 'ds-challenges.objective.frequency_plural' : 'ds-challenges.objective.frequency', {
      repeat: conditions.repeat,
      frequencyName: t("ds-challenges.objective.frequency_".concat(conditions.frequency)),
      frequency: conditions.frequencyRepeat > 1 ? t("ds-challenges.objective.frequency_".concat(conditions.frequency, "_plural")) : t("ds-challenges.objective.frequency_".concat(conditions.frequency)),
      frequencyRepeat: conditions.frequencyRepeat
    }));
  }

  return objectiveName;
};

var getLiteralObjective = function getLiteralObjective(_ref2) {
  var _conditions$userActio2, _conditions$userActio3, _conditions$userActio4;

  var conditions = _ref2.conditions,
      objective = _ref2.objective,
      _ref2$measurementSyst = _ref2.measurementSystem,
      measurementSystem = _ref2$measurementSyst === void 0 ? 'metric' : _ref2$measurementSyst,
      _ref2$separatedValues = _ref2.separatedValues,
      separatedValues = _ref2$separatedValues === void 0 ? false : _ref2$separatedValues,
      t = _ref2.t,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? 'en' : _ref2$locale;
  var literal = '';

  if (objective && !separatedValues) {
    return (0, _formatStringWithMeasurementSystem["default"])({
      objective: t(objective),
      measurementSystem: measurementSystem,
      locale: locale
    });
  }

  if (!conditions) {
    return '';
  }

  if (conditions.repeat && !(conditions === null || conditions === void 0 ? void 0 : conditions.frequency) && !(conditions === null || conditions === void 0 ? void 0 : conditions.frequencyRepeat)) {
    literal += "".concat(conditions.repeat, " x ");
  }

  if (((_conditions$userActio2 = conditions === null || conditions === void 0 ? void 0 : (_conditions$userActio3 = conditions.userActionsTypes) === null || _conditions$userActio3 === void 0 ? void 0 : _conditions$userActio3.length) !== null && _conditions$userActio2 !== void 0 ? _conditions$userActio2 : 0) > 0 && !(conditions === null || conditions === void 0 ? void 0 : (_conditions$userActio4 = conditions.userActionsTypes) === null || _conditions$userActio4 === void 0 ? void 0 : _conditions$userActio4.includes(_types.UserActionsType.BONUS_APPLIED))) {
    return getUserActionLiteralObjective({
      literal: literal,
      conditions: conditions,
      t: t,
      locale: locale
    });
  }

  if (conditions.noObjective) {
    if (separatedValues) {
      var unit = conditions.unit;
      var label = t('ds-challenges.progression.cumulated');
      var unitLabel = t('ds-challenges.objective.point');

      if (unit !== 'points' && unit !== 'duration') {
        unitLabel = t("ds-leaderboard.unit.".concat((0, _extractTargetUnit["default"])({
          measurementSystem: measurementSystem,
          unit: unit
        })));
      }

      if (unit === 'duration') {
        unitLabel = t('generic.hour');
        label = t('ds-challenges.progression.cumulated_feminine');
      }

      return {
        label: "".concat(unitLabel, " ").concat(label),
        value: 0
      };
    }

    literal += '';
  }

  if (conditions.minPoints) {
    var value = conditions.minPoints;

    if (separatedValues) {
      return {
        label: "".concat(t('ds-challenges.objective.point'), " ").concat(t('ds-challenges.objective.to-cumulate')),
        value: value
      };
    }

    literal += "".concat((0, _formatNumber["default"])(value, {
      locale: locale
    }), " ").concat(t('ds-challenges.objective.point', {
      count: value
    }));
  }

  if (conditions.minDistance) {
    var _value = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: conditions.minDistance,
      measurementSystem: measurementSystem,
      unit: 'distance'
    });

    var _unit = t("ds-leaderboard.unit.".concat((0, _extractTargetUnit["default"])({
      measurementSystem: measurementSystem,
      unit: 'distance'
    })));

    if (separatedValues) {
      return {
        label: "".concat(_unit, " ").concat(t('ds-challenges.objective.to-cumulate')),
        value: _value
      };
    }

    literal += "".concat((0, _formatNumber["default"])(_value, {
      locale: locale
    }), " ").concat(_unit);
  }

  if (conditions.minClimb) {
    var _value2 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: conditions.minClimb,
      measurementSystem: measurementSystem,
      unit: 'climb'
    });

    var _unit2 = t("ds-leaderboard.unit.".concat((0, _extractTargetUnit["default"])({
      measurementSystem: measurementSystem,
      unit: 'climb'
    })));

    if (separatedValues) {
      return {
        label: "".concat(_unit2, " ").concat(t('ds-challenges.objective.to-cumulate')),
        value: _value2
      };
    }

    literal += "".concat((0, _formatNumber["default"])(_value2, {
      locale: locale
    }), " ").concat(_unit2, " ").concat(t('ds-challenges.objective.climb'));
  }

  if (conditions.minDescent) {
    var _value3 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: conditions.minDescent,
      measurementSystem: measurementSystem,
      unit: 'descent'
    });

    var _unit3 = t("ds-leaderboard.unit.".concat((0, _extractTargetUnit["default"])({
      measurementSystem: measurementSystem,
      unit: 'descent'
    })));

    if (separatedValues) {
      return {
        label: "".concat(_unit3, " ").concat(t('ds-challenges.objective.to-cumulate')),
        value: _value3
      };
    }

    literal += "".concat((0, _formatNumber["default"])(_value3, {
      locale: locale
    }), " ").concat(_unit3, " ").concat(t('ds-challenges.objective.descent'));
  }

  if (conditions.minDuration) {
    var conditionInHours = conditions.minDuration / 3600;
    var minutes = Math.round(conditionInHours % 1 * 60);
    var hours = Math.floor(conditionInHours);

    if (separatedValues) {
      return {
        label: "".concat(t('generic.hour'), " ").concat(t('ds-challenges.objective.to-cumulate')),
        value: hours
      };
    }

    if (hours >= 1) {
      literal += "".concat(hours, " ").concat(t('generic.hour', {
        count: hours
      }), " ");
    }

    if (minutes > 0) {
      literal += "".concat(minutes, " ").concat(t('generic.minute', {
        count: minutes
      }));
    }
  }

  if (conditions.attempt && !(conditions.repeat && conditions.attempt === 1)) {
    literal += " ".concat(t('ds-challenges.objective.attempt', {
      count: conditions.attempt
    }));
  }

  if (!!conditions.frequency && !!conditions.frequencyRepeat && !!(conditions === null || conditions === void 0 ? void 0 : conditions.repeat)) {
    literal += "".concat(t((conditions === null || conditions === void 0 ? void 0 : conditions.repeat) > 1 ? 'ds-challenges.objective.frequency_plural' : 'ds-challenges.objective.frequency', {
      repeat: conditions.repeat,
      frequencyName: t("ds-challenges.objective.frequency_".concat(conditions.frequency)),
      frequency: conditions.frequencyRepeat > 1 ? t("ds-challenges.objective.frequency_".concat(conditions.frequency, "_plural")) : t("ds-challenges.objective.frequency_".concat(conditions.frequency)),
      frequencyRepeat: conditions.frequencyRepeat
    }));
  }

  return literal;
};

var _default = getLiteralObjective;
exports["default"] = _default;
//# sourceMappingURL=getLiteralObjective.js.map